module.exports = __webpack_public_path__ + "media/country_flags/pr-74e4727c.png";